export default "<nb-card>\r\n    <nb-card-header>\r\n        Economic Calendar\r\n    </nb-card-header>\r\n    <nb-card-body></nb-card-body>\r\n</nb-card>";